/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import {
  colors,
  cssMediaQueryMinWidthDesktop,
  HandlebarIcon,
  IconButton,
  numericPixels,
  radius,
  spacing,
  stroke,
} from "@packages/ui";
import { Close as DialogClose } from "@radix-ui/react-dialog";
import { Button as ToolbarButton } from "@radix-ui/react-toolbar";
import { HallowDataTestId } from "@tools/playwright/global";
import type { MouseEventHandler } from "react";
import { forwardRef } from "react";

const collapseStyle: Interpolation = {
  border: stroke.none,
  borderBottomLeftRadius: radius.m,
  borderBottomRightRadius: radius.m,
  borderTopLeftRadius: radius.none,
  borderTopRightRadius: radius.none,
  cursor: "pointer",
  display: "flex",
  height: spacing.xl,
  paddingBlock: spacing.xxs,
  paddingInline: spacing.m,
  placeContent: "center",
  placeItems: "center",
  width: numericPixels[80],
  [cssMediaQueryMinWidthDesktop]: {
    borderBottomLeftRadius: radius.full,
    borderBottomRightRadius: radius.full,
    borderTopLeftRadius: radius.full,
    borderTopRightRadius: radius.full,
  },
};
const iconStyle: Interpolation = {
  display: "flex",
  flexShrink: 0,
};

export type CollapseButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const CollapseButton = forwardRef<
  HTMLButtonElement,
  CollapseButtonProps
>(({ onClick }, ref) => (
  <ToolbarButton asChild>
    <DialogClose asChild>
      <IconButton
        ref={ref}
        icon={<HandlebarIcon fill={colors.white} css={iconStyle} />}
        css={collapseStyle}
        variant={"lighten"}
        data-testid={HallowDataTestId.MediaCollapse}
        onClick={onClick}
        tabIndex={0}
      />
    </DialogClose>
  </ToolbarButton>
));

CollapseButton.displayName = "CollapseButton";
